import { viewLocationData } from "./Location"

export type  RobotListData = {
    id: number,
    name: string,
    robotType: number,
    move_state: number,
    robot_state: string,
    location: viewLocationData,
    image: string,
    door_open: boolean,
    charge_stage: number,
    robot_mode: RobotMode,
    battery: number,
}

export const rMapRobotType = {
    1: "FLASHBOT",
}

export type  RobotDetailData = RobotListData & {
    batteryStatus: string,
    currentLocation: string,
    robotState_str: string,
}

export type QueryRobotInfo = {
    robotIds: number[]
}

export enum RobotMode {
    AUTO = 1,
    MANUAL = 2
}

export enum MoveState {
    IDLE = 0, 
    MOVING = 1, 
    STUCK = 2, 
    ARRIVE = 3, 
    PAUSE = 4, 
    APPROACHING = 5,
    ERROR = 6, }

export enum RobotState {
    FREE = 0,
    BUSY = 1,
    ESTOP = 2,
    OFFLINE = 3,
}

export enum ChargeStatus {
    IDLE = 0, 
    CHARGING = 1, 
    CHARGEFULL = 2, 
    CHARGEERRORCONTACT = 3, 
    CHARGEERRORELECTRIC = 4, 
    ERRORBATTERYPACKCOMM = 5, 
    CHARGINGUSEPILE = 6, 
    CHARGEFULLUSEPILE = 7,
}

export const rMapMoveState = {
    0: "Idle",
    1: "Moving",
    2: "Stuck",
    3: "Arrive",
    4: "Pause",
    5: "Approaching",
    6: "Error"
}

export const rMapRobotState = {
    0: "Free",
    1: "Busy",
    2: "Emergency Stop Pressed",
    3: "Offline"
}

export const rMapChargeStatus = {
    0: "Idle",
    1: "Charging",
    2: "Charge Full",
    3: "Charge Error Contact",
    4: "Charge Error Electric",
    5: "Error Battery Pack Comm",
    6: "Charging Use Pile", // Note there is a typo in official docs in PUDU
    7: "Charge Full Use Pile",
}